function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { WDHComponent, isMobileDevice } from '../../../../wdh-foundation/wdh';
import Slider from 'slick-carousel/slick/slick.min.js';
var $ = jQuery;
/**
 * @module wdh-text-image-spot
 */

var WDHTextImageSpot = /*#__PURE__*/function (_WDHComponent) {
  _inherits(WDHTextImageSpot, _WDHComponent);

  var _super = _createSuper(WDHTextImageSpot);

  /**
     * Base WDHTextImageSpot component
     * @augments WDHComponent
     * @inheritDoc
     * @param className
     */
  function WDHTextImageSpot() {
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'text-image-spot';

    _classCallCheck(this, WDHTextImageSpot);

    return _super.call(this, className);
  }

  _createClass(WDHTextImageSpot, [{
    key: "init",
    value: function init(component) {
      var imageLists = this.getImagesListFromComponent(component);
      var images = component.querySelectorAll('.text-image-spot-element img');
      var mainImgContainer = component.querySelectorAll('.text-image-spot-image-container');
      var mainImg = this.getMainImageFromComponent(component);

      if (imageLists.length > 0) {
        component.classList.add('multiple-images');
        $(mainImgContainer).append(imageLists);
        $(images).click(function () {
          var _this = this;

          $(mainImg).fadeOut(10, function () {
            $(mainImg).attr('src', $(_this).attr('src'));
          }).fadeIn(100);
        });
      }

      if (images.length > 4) {
        $(imageLists).children().each(function (i, elem) {
          $(imageLists).prepend(elem);
        });
        $(imageLists).slick({
          infinite: false,
          slidesToShow: 4,
          slidesToScroll: 3
        });
      }
    }
  }, {
    key: "resize",
    value: function resize(component) {
      var imageLists = this.getImagesListFromComponent(component);
      var mainImg = this.getMainImageFromComponent(component);

      if (isMobileDevice()) {
        $(imageLists).css('width', 'auto');
      } else {
        $(imageLists).width($(mainImg).width() - 40);
      }
    }
  }, {
    key: "getImagesListFromComponent",
    value: function getImagesListFromComponent(component) {
      return component.querySelectorAll('.text-image-spot-image-elements');
    }
  }, {
    key: "getMainImageFromComponent",
    value: function getMainImageFromComponent(component) {
      return component.querySelectorAll('.text-image-spot-image-container .text-image-spot-image > img');
    }
  }]);

  return WDHTextImageSpot;
}(WDHComponent);

export default WDHTextImageSpot;